import axios from "axios";

const host = process.env.REACT_APP_HOST_API;
const port = process.env.REACT_APP_PORT_API;

export async function fetchDataGet(rota) {
  let endpoint = `${rota}`;
  if (host === "localhost") {
    endpoint = `http://${host}:${port}${rota}`;
  }
  try {
    const response = await axios.get(endpoint);

    return response.data;
  } catch (error) {
    console.error("Erro ao obter os dados:", error);
  }
}

export async function fetchDataPost(rota, data) {
  let endpoint = `${rota}`;
  if (host === "localhost") {
    endpoint = `http://${host}:${port}${rota}`;
  }
  try {
    const response = await axios.post(
      endpoint,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao enviar os dados:", error);
    throw error;
  }
}

export async function fetchAnaliseIA(imageBase64, titulo, chartData = null) {
  let endpoint = "/api/analise_grafico";
  if (host === "localhost") {
    endpoint = `http://${host}:${port}/api/analise_grafico`;
  }
  try {
    const response = await axios.post(
      endpoint,
      { image: imageBase64, titulo, chartData },
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data.analise;
  } catch (error) {
    console.error("Erro ao obter análise da IA:", error);
    return null;
  }
}
